export default {
  home: 'Ana Sayfa',
  map: 'Harita',
  login: 'Giriş yap',
  registration: 'Kayıt ol'
}
